import React from 'react';

//Components
import {ChevronRight} from "react-feather";

//Styles
import Styles from './ButtonInput.module.scss';

//Utils
import PropTypes from 'prop-types';
import _ from 'lodash';

const ButtonInput = ({name, onClick, disabled}) => {

    return (
        <div className={Styles.container}>
            <label className={Styles.label}>
                {name}
            </label> 
            <ChevronRight className={Styles.chevron} color='#818E9C' size={22}/>
            <input
                disabled={disabled}
                value={_.times(name.length, () => '●').join('')}
                type='button'
                onClick={onClick}
            />
        </div>
    );
};

ButtonInput.propTypes = {
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
};

export default ButtonInput
